import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import HomeLayout from "../layouts/home_layout";
// import Portfolio from "../pages/portfolio.main.backup";
import Funds from "../pages/funds";
import Goals from "../pages/goals";
import Articles from "../pages/articles";
import Glossary from "../pages/glossary";
import Faqs from "../pages/FAQs";
import ProtectedRoute from "../routes/protected_route";
import PublicRoute from "../routes/public_route";
import Login from "../pages/login";
import Dashboard from "../pages/dashboard";
import Signup from "../pages/signup";
import NotFoundPage from "../pages/404";
import DocumentVerification from "../pages/docs-verify";
import ForgotPasswordPage from "../pages/forgot-password";
import ForgotPasswordUpdatePage from "../pages/forgot-password-update";
import UpdatePasswordPage from "../pages/change-password";
import Requests from "../pages/requests";
import { LearnLayout } from "../pages/learn";
import RequiresAuth from "../components/requireAuth";
import FundDetails from "../pages/fundDetails";
import InvestLayout from "../layouts/invest_layout";
import AuthPage from "../pages/auth";
import PortfolioChart from "../components/portfolioChart";
import PortfolioLayout from "../layouts/portfolio_layout";
import VerificationPage from "../pages/verify";
// import DashboardLayoutSelector from "./dashboard-layout-selector";

// function DashboardLayoutSelector() {
// 	const { user } = useAuth();

// 	return user ? <HomeLayout /> : <GuestLayout />
// }

const router = createBrowserRouter([
  {
    path: "/",
    // element: <LandingPage />,
    element: (
      <ProtectedRoute>
        <HomeLayout />
        {/* <DashboardLayoutSelector /> */}
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to='dashboard' replace />,
      },
      {
        path: "unlock",
        element: <AuthPage />,
      },
      {
        path: "verify",
        element: <VerificationPage />,
      },
      {
        path: "auth/login",
        element: <Login />,
      },
      {
        path: "/auth/signup",
        element: (
          <Signup />
        ),
      },
      {
        path: "/auth/verify",
        element: (
          <DocumentVerification />
        ),
      },
      {
        path: "/auth/recover",
        element: (
          <ForgotPasswordPage />
        ),
      },
      {
        path: "/auth/recover/update",
        element: (
          <ForgotPasswordUpdatePage />
        ),
      },
      {
        path: "/change-password",
        element: (
          <UpdatePasswordPage />
        ),
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "invest",
        element: <Funds />,
        // children: [
        //   { index: true, element: <Funds /> },
        //   { path: ":symbol", element: <FundDetails /> }
        // ],
      },
      {
        path: "portfolio",
        element: (
          <RequiresAuth>
            <PortfolioLayout />
          </RequiresAuth>
        ),
      },
      {
        path: "goals",
        element: <Goals />,
      },
      {
        path: "learn",
        element: <LearnLayout />,
        children: [
          { index: true, element: <Navigate to="glossary" replace /> },
          // { path: "articles", element: <Articles /> },
          { path: "glossary", element: <Glossary /> },
          { path: "faqs", element: <Faqs /> },
        ]
      },
      {
        path: "requests",
        element: <Requests />,
      },
      // {
      //   path: "learn/articles",
      //   element: <Articles />,
      // },
      // {
      //   path: "learn/glossary",
      //   element: <Glossary />,
      // },
      // {
      //   path: "learn/faqs",
      //   element: <Faqs />,
      // },
    ],
  },
  // {
  //   path: "/auth",
  //   element: (
  //     <PublicRoute>
  //       <Navigate to='/auth/login' replace />
  //     </PublicRoute>
  //   ),
  // },
  // {
  //   path: "/auth/login",
  //   element: (
  //     <PublicRoute>
  //       <Login />
  //     </PublicRoute>
  //   ),
  // },
  // {
  //   path: "/auth/signup",
  //   element: (
  //     <PublicRoute>
  //       <Signup />
  //     </PublicRoute>
  //   ),
  // },
  // {
  //   path: "/auth/verify",
  //   element: (
  //     // <PublicRoute>
  //     <DocumentVerification />
  //     // </PublicRoute>
  //   ),
  // },
  // {
  //   path: "/auth/recover",
  //   element: (
  //     // <PublicRoute>
  //     <ForgotPasswordPage />
  //     // </PublicRoute>
  //   ),
  // },
  // {
  //   path: "/auth/recover/update",
  //   element: (
  //     // <PublicRoute>
  //     <ForgotPasswordUpdatePage />
  //     // </PublicRoute>
  //   ),
  // },
  // {
  //   path: "/change-password",
  //   element: (
  //     // <PublicRoute>
  //     <UpdatePasswordPage />
  //     // </PublicRoute>
  //   ),
  // },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

export default router;
